import { creatorHref } from "~/modules/askgvt/discovery/utils/creatorHref";

export type CreatorProfileShareChannel =
	| "whatsapp"
	| "messages"
	| "email"
	| "x"
	| "facebook"
	| "reddit"
	| "linkedin"
	| "telegram"
	| "slack";

export function creatorProfilePath(handle: string): string {
	return creatorHref(handle);
}

/** Host + path for display in the share field (no protocol). */
export function creatorProfileDisplayUrl(handle: string): string {
	const path = creatorProfilePath(handle);
	if (typeof window === "undefined") {
		return path.replace(/^\//, "");
	}
	return `${window.location.host}${path}`;
}

/** Absolute URL for clipboard and share intents. */
export function creatorProfileShareUrl(handle: string): string {
	const path = creatorProfilePath(handle);
	if (typeof window === "undefined") {
		return path;
	}
	return `${window.location.origin}${path}`;
}

export function creatorShareTitle(displayName: string): string {
	return `${displayName} on AskGVT`;
}

export function creatorShareText(displayName: string): string {
	return `Check out ${displayName} on AskGVT`;
}

/** Opens Slack in the browser; pair with copying the profile link (Slack has no public share URL). */
export const SLACK_WEB_APP_URL = "https://app.slack.com/client";

/**
 * Returns a navigable share URL for the channel, or null when the platform has
 * no reliable web intent. Slack uses copy + open instead (see ShareCreatorButton).
 */
export function creatorProfileShareChannelUrl(
	channel: CreatorProfileShareChannel,
	options: { url: string; title: string; text: string },
): string | null {
	const encodedUrl = encodeURIComponent(options.url);
	const encodedTitle = encodeURIComponent(options.title);
	const body = `${options.text}\n\n${options.url}`;

	switch (channel) {
		case "whatsapp":
			return `https://wa.me/?text=${encodeURIComponent(body)}`;
		case "messages":
			return `sms:?&body=${encodeURIComponent(`${options.text} ${options.url}`)}`;
		case "email":
			return `mailto:?subject=${encodedTitle}&body=${encodeURIComponent(body)}`;
		case "x":
			return `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodeURIComponent(options.text)}`;
		case "facebook":
			return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
		case "reddit":
			return `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`;
		case "linkedin":
			return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
		case "telegram":
			return `https://t.me/share/url?url=${encodedUrl}&text=${encodeURIComponent(options.text)}`;
		case "slack":
			return null;
		default:
			return null;
	}
}
